import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/BookingContactModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FooterV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/NavbarV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/TopLoaderBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/WhatsAppButton.tsx");
